import styled from 'styled-components';
import { Panel } from 'rsuite';

export const Card = styled(Panel)`
  background: #fff;
  border-color: #dfe4ea;

  .rs-panel-heading {
    padding: 18px 20px;
    border-bottom: 1px solid #edf0f2;
  }

  .rs-panel-body {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  strong {
    color: #172b4d;
    font-size: 16px;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(240px, 34%) minmax(0, 1fr);
  gap: 22px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const DocumentColumn = styled.div`
  min-width: 0;
`;

export const DetailsColumn = styled.div`
  min-width: 0;
`;

export const AnalysisLoading = styled.div`
  display: flex;
  min-height: 220px;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 28px;
  border: 1px solid #d9e8fb;
  border-radius: 6px;
  background: #f4f9ff;

  strong,
  span {
    display: block;
  }

  strong {
    margin-bottom: 4px;
    color: #172b4d;
    font-size: 15px;
  }

  span {
    color: #6b778c;
    line-height: 1.45;
  }
`;

export const DocumentPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  overflow: hidden;
  border: 1px solid #dfe4ea;
  border-radius: 6px;
  background: #f4f5f7;
  color: #6b778c;
`;

export const DocumentImage = styled.img`
  display: block;
  width: 100%;
  max-height: 430px;
  object-fit: contain;
`;

export const DocumentPdf = styled.iframe`
  display: block;
  width: 100%;
  height: 430px;
  border: 0;
`;

export const DocumentPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  text-align: center;
`;

export const DocumentLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  color: #1675e0;
  font-size: 13px;
`;

export const Metadata = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
`;

export const MetadataItem = styled.div`
  min-width: 150px;
  padding: 10px 14px;
  border: 1px solid #edf0f2;
  border-radius: 6px;
  background: #f8fafc;

  span {
    display: block;
    margin-bottom: 2px;
    color: #6b778c;
    font-size: 12px;
  }

  strong {
    color: #172b4d;
    font-size: 14px;
    text-transform: capitalize;
  }
`;

export const SectionTitle = styled.h5`
  margin: 0 0 10px;
  color: #172b4d;
  font-size: 14px;
`;

export const Checklist = styled.table`
  width: 100%;
  margin-bottom: 18px;
  border: 1px solid #e5e9ef;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 6px;
  overflow: hidden;

  th,
  td {
    padding: 11px 14px;
    text-align: left;
  }

  th {
    color: #6b778c;
    background: #f8fafc;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 80px;
    text-align: center;
  }

  th:last-child,
  td:last-child {
    width: 240px;
  }

  td {
    color: #344563;
    border-top: 1px solid #edf0f2;
  }
`;

export const CheckResult = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: ${(props) => {
    if (props.$state === 'approved') return '#16883f';
    if (props.$state === 'attention') return '#b76e00';
    return '#c9372c';
  }};
  font-weight: 600;
`;

export const Reason = styled.span`
  color: ${(props) => {
    if (props.$state === 'attention') return '#805500';
    if (props.$state === 'failed') return '#5d2630';
    return '#6b778c';
  }};
  font-size: 13px;
`;

export const Problems = styled.div`
  margin-bottom: 18px;
  padding: 14px 16px;
  border-left: 3px solid
    ${(props) => (props.$attentionOnly ? '#d99000' : '#e5484d')};
  border-radius: 4px;
  background: ${(props) => (props.$attentionOnly ? '#fff9e8' : '#fff5f5')};

  ul {
    margin: 8px 0 0;
    padding-left: 20px;
    color: ${(props) => (props.$attentionOnly ? '#664d00' : '#5d2630')};
  }

  li + li {
    margin-top: 5px;
  }
`;

export const FeedbackSection = styled.div`
  padding-top: 18px;
  border-top: 1px solid #edf0f2;

  p {
    margin: 4px 0 10px;
    color: #6b778c;
  }
`;

export const FeedbackActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;

  small {
    color: #6b778c;
  }
`;
